<template>
  <div v-if="variants.v1 === variant && property">
    <section class="n-section-primary !tw-pb-0 !tw-pt-36" style="background-color: #eaf3f3">
      <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar color="var(--c-primary)" />
        </div>
        <div class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between">
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
            <h2 class="tw-leading-tight">{{ property.advert_heading }}</h2>
            <div
              v-if="property.custom_property_status_title"
              class="tw-my-2 tw-w-fit tw-p-2"
              style="background-color: var(--c-primary); color: white; border-radius: var(--rounded)"
            >
              {{ property.custom_property_status_title }}
            </div>
            <template v-if="!property.is_locked">
              <div class="tw-mt-3 tw-flex tw-items-center tw-gap-1 tw-pb-4">
              <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.944 3.25H13.056C14.894 3.25 16.35 3.25 17.489 3.403C18.661 3.561 19.61 3.893 20.359 4.641C21.107 5.39 21.439 6.339 21.597 7.511C21.748 8.637 21.75 10.071 21.75 11.879C22.094 12.162 22.367 12.529 22.54 12.948C22.661 13.238 22.708 13.538 22.73 13.855C22.75 14.159 22.75 14.53 22.75 14.975V15.025C22.75 15.47 22.75 15.841 22.73 16.145C22.7171 16.4557 22.6529 16.7622 22.54 17.052C22.4019 17.3857 22.1994 17.689 21.9441 17.9445C21.6888 18.2 21.3857 18.4027 21.052 18.541C20.762 18.661 20.462 18.708 20.145 18.729C20.0135 18.7378 19.8818 18.7434 19.75 18.746V20C19.75 20.1989 19.671 20.3897 19.5303 20.5303C19.3897 20.671 19.1989 20.75 19 20.75C18.8011 20.75 18.6103 20.671 18.4697 20.5303C18.329 20.3897 18.25 20.1989 18.25 20V18.75H5.75V20C5.75 20.1989 5.67098 20.3897 5.53033 20.5303C5.38968 20.671 5.19891 20.75 5 20.75C4.80109 20.75 4.61032 20.671 4.46967 20.5303C4.32902 20.3897 4.25 20.1989 4.25 20V18.745C4.11823 18.7428 3.98652 18.7374 3.855 18.729C3.54438 18.7167 3.23791 18.6532 2.948 18.541C2.61416 18.4028 2.31082 18.2002 2.05533 17.9447C1.79984 17.6892 1.5972 17.3858 1.459 17.052C1.339 16.762 1.292 16.462 1.271 16.145C1.25 15.841 1.25 15.47 1.25 15.025V14.975C1.25 14.53 1.25 14.159 1.27 13.855C1.292 13.537 1.34 13.238 1.46 12.948C1.63182 12.5321 1.90308 12.1647 2.25 11.878C2.25 10.072 2.252 8.637 2.403 7.511C2.561 6.339 2.893 5.39 3.641 4.641C4.39 3.893 5.339 3.561 6.511 3.403C7.651 3.25 9.106 3.25 10.944 3.25ZM3.75 11.279C4.08288 11.2575 4.41643 11.2478 4.75 11.25V10.448C4.75 9.55 4.75 8.8 4.83 8.206C4.914 7.578 5.1 7.011 5.555 6.556C6.011 6.1 6.578 5.914 7.205 5.83C7.8 5.75 8.55 5.75 9.448 5.75H14.552C15.451 5.75 16.2 5.75 16.794 5.83C17.422 5.914 17.989 6.1 18.444 6.555C18.9 7.011 19.086 7.578 19.17 8.205C19.25 8.8 19.25 9.55 19.25 10.448V11.25C19.5836 11.2478 19.9171 11.2575 20.25 11.279C20.247 9.744 20.23 8.604 20.11 7.711C19.975 6.705 19.721 6.125 19.298 5.701C18.875 5.279 18.295 5.025 17.289 4.89C16.262 4.752 14.907 4.75 13 4.75H11C9.093 4.75 7.739 4.752 6.71 4.89C5.705 5.025 5.125 5.279 4.702 5.702C4.279 6.125 4.025 6.705 3.89 7.711C3.77 8.604 3.753 9.744 3.75 11.279ZM17.75 11.25V10.5C17.75 9.536 17.748 8.888 17.683 8.405C17.621 7.944 17.514 7.746 17.383 7.616C17.253 7.486 17.056 7.379 16.595 7.316C16.112 7.252 15.464 7.25 14.5 7.25H12.75V11.25H17.75ZM11.25 11.25V7.25H9.5C8.536 7.25 7.888 7.252 7.405 7.317C6.944 7.379 6.746 7.486 6.616 7.617C6.486 7.747 6.379 7.944 6.316 8.405C6.252 8.888 6.25 9.536 6.25 10.5V11.25H11.25ZM3.957 12.767C3.716 12.784 3.599 12.813 3.522 12.845C3.3702 12.9078 3.23228 12.9999 3.11611 13.1161C2.99995 13.2323 2.90782 13.3702 2.845 13.522C2.813 13.599 2.784 13.716 2.767 13.957C2.75 14.204 2.75 14.524 2.75 15C2.75 15.476 2.75 15.796 2.767 16.043C2.784 16.284 2.813 16.401 2.845 16.478C2.972 16.785 3.215 17.028 3.522 17.155C3.599 17.187 3.716 17.216 3.957 17.233C4.204 17.25 4.524 17.25 5 17.25H19C19.476 17.25 19.796 17.25 20.043 17.233C20.284 17.216 20.401 17.187 20.478 17.155C20.785 17.028 21.028 16.785 21.155 16.478C21.187 16.401 21.216 16.284 21.233 16.043C21.25 15.796 21.25 15.476 21.25 15C21.25 14.524 21.25 14.204 21.233 13.957C21.216 13.716 21.187 13.599 21.155 13.522C21.0922 13.3702 21.0001 13.2323 20.8839 13.1161C20.7677 12.9999 20.6298 12.9078 20.478 12.845C20.401 12.813 20.284 12.784 20.043 12.767C19.6956 12.7507 19.3478 12.745 19 12.75H5C4.524 12.75 4.204 12.75 3.957 12.767Z"
                      fill="#6EADAB"
                    />
                  </svg>
                  <p>Beds: {{ property.bedroom }}</p>
                </div>

                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_428_289)">
                      <path
                        d="M2.25 13.1243H20.25V4.68677C20.2509 4.36902 20.1887 4.05425 20.0671 3.76069C19.9455 3.46712 19.7669 3.2006 19.5416 2.97653L19.5228 2.95778C19.1697 2.60521 18.7164 2.37024 18.2248 2.28499C17.7331 2.19973 17.2271 2.26834 16.776 2.48144C17.2021 3.1899 17.3792 4.02046 17.2791 4.84112C17.1791 5.66178 16.8077 6.42547 16.2239 7.01083L15.7105 7.52416L16.6554 8.46906L15.5948 9.52966L14.6499 8.5848L9.41451 3.34947L8.46966 2.40461L9.5303 1.34397L10.4752 2.28883L10.9885 1.7755C11.6031 1.16263 12.4133 0.784826 13.2778 0.707939C14.1424 0.631052 15.0065 0.859952 15.7196 1.35475C16.4715 0.879867 17.3627 0.674856 18.2465 0.773397C19.1304 0.871937 19.9545 1.26817 20.5834 1.897L20.6022 1.91575C20.9672 2.2788 21.2566 2.71064 21.4536 3.18629C21.6507 3.66193 21.7514 4.17193 21.75 4.68677V13.1243H23.25V14.6243H21.75V16.0633C21.75 16.1842 21.7305 16.3044 21.6923 16.4191L20.2969 20.605C20.2224 20.8291 20.0792 21.0241 19.8877 21.1621C19.6961 21.3002 19.4659 21.3745 19.2297 21.3743H18.625L19.1719 23.2493H17.6094L17.0625 21.3743H7.30781L6.74531 23.2493H5.17969L5.74219 21.3743H4.77047C4.53428 21.3745 4.30403 21.3003 4.11242 21.1622C3.92081 21.0241 3.7776 20.8291 3.70312 20.605L2.30784 16.4191C2.26956 16.3044 2.25002 16.1842 2.25 16.0633V14.6243H0.75V13.1243H2.25ZM15.1631 2.83614C14.7499 2.42379 14.1899 2.19221 13.6061 2.19221C13.0224 2.19221 12.4624 2.42379 12.0492 2.83614L11.5359 3.34947L14.6498 6.46333L15.1631 5.9501C15.5755 5.53684 15.807 4.9769 15.807 4.39312C15.807 3.80934 15.5755 3.2494 15.1631 2.83614ZM3.75 16.0024L5.04056 19.8743H18.9594L20.25 16.0024V14.6243H3.75V16.0024Z"
                        fill="#6EADAB"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_428_289">
                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                      </clipPath>
                    </defs>
                  </svg>

                  <p>Baths: {{ property.bathroom }}</p>
                </div>
                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21 9V7C21 5.35 19.65 4 18 4H14C13.23 4 12.53 4.3 12 4.78C11.47 4.3 10.77 4 10 4H6C4.35 4 3 5.35 3 7V9C1.35 9 0 10.35 0 12V17C0 18.65 1.35 20 3 20V22H5V20H19V22H21V20C22.65 20 24 18.65 24 17V12C24 10.35 22.65 9 21 9ZM14 6H18C18.55 6 19 6.45 19 7V9.78C18.39 10.33 18 11.12 18 12V14H13V7C13 6.45 13.45 6 14 6ZM5 7C5 6.45 5.45 6 6 6H10C10.55 6 11 6.45 11 7V14H6V12C6 11.12 5.61 10.33 5 9.78V7ZM22 17C22 17.55 21.55 18 21 18H3C2.45 18 2 17.55 2 17V12C2 11.45 2.45 11 3 11C3.55 11 4 11.45 4 12V16H20V12C20 11.45 20.45 11 21 11C21.55 11 22 11.45 22 12V17Z"
                      fill="#6EADAB"
                    />
                  </svg>
                  <p>Receptions: {{ property.reception }}</p>
                </div>
              </div>
            </div>
            </template>
            <div class="tw-mt-2 tw-flex tw-items-center tw-gap-1">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="var(--c-primary)"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="var(--c-primary)"
                />
              </svg>
              <p class="tw-capitalize">{{ property.display_address }}</p>
            </div>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-py-16 lg:tw-py-24 lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
            :class="{'tw-py-4': property.is_locked}"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
            >
            <template v-if="!property.is_locked">
              <button class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
            </template>

              <button class="n-secondary" @click="onShared()">SHARE</button>
            </div>
            <div class="tw-pt-6">
              <div v-if="property.price">
                <p v-if="property.price.type.name">
                  {{ property.price.type.name }}
                </p>
                <h5 class="!tw-text-3xl" style="color: var(--c-primary)">
                  {{ property.price.price }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="n-section-primary !tw-pt-0" style="background-color: #eaf3f3">
      <div class="tw-grid tw-w-full tw-grid-cols-12 md:tw-gap-x-10">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8"
          :class="{'lg:!tw-col-span-12 xl:!tw-col-span-7': property.is_locked}">
          <div class="tw-grid tw-w-full tw-grid-cols-8 tw-gap-1">
            <!-- GALLERY START -->
            <div class="tw-relative tw-col-span-6 tw-flex tw-flex-col lg:tw-col-span-6 property-detail-image-container">
              <library-image
                :src="property.image"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[0])"
                :title="property.advert_heading"
                :w-ratio="3"
                :h-ratio="2"
                image-class="tw-h-full"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />

              <div class="nc-first-image-overlay-item">
                <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                  1/{{ property.medias.length }}
                </div>
              </div>
            </div>
            <div class="tw-col-span-2 tw-flex tw-flex-col tw-gap-1 lg:tw-col-span-2">
              <library-image
                :src="primaryFourPhotos[1].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[1])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                :src="primaryFourPhotos[2].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[2])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                :src="primaryFourPhotos[3].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[3])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                :src="primaryFourPhotos[4].background"
                alt="property first image"
                @click="onClickedImage(primaryFourPhotos[4])"
                :title="property.advert_heading"
                :w-ratio="7"
                :h-ratio="4"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>
            <!-- GALLERY END -->
          </div>

          <!-- Property Detail -->
          <div v-if="!property.is_locked" class="tw-flex tw-flex-col tw-gap-16">
            <!-- Property Video -->
            <div v-if="property?.featured_video">
              <h3 class="tw-pb-8">Property Video</h3>
              <library-video-embed :video-url="propertyVideo(property?.featured_video.mediaLink)" :is-popup="true" />
            </div>
            <!-- Features -->
            <div>
              <h3>Features</h3>
              <div class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                <div
                  v-for="(feature, index) in property.features"
                  :key="`property-feature-${index}`"
                  class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                >
                  <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>
                  <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                </div>
              </div>
            </div>

            <!-- Property Info -->
            <div v-if="property.description">
              <h3 class="tw-pb-4">Property Info</h3>
              <div v-html="property.description"></div>
            </div>

            <!-- Floor Plan -->
            <div v-if="property.floor_plans">
              <h3>Floor Plans</h3>
              <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
            </div>

            <!-- Map -->
            <div v-if="property.map_position && property.map_position.lat && property.map_position.lng">
              <h3 class="tw-pb-8">Map</h3>
              <neuron-google-map
                v-model:map-center-position="property.map_position"
                :component="component"
                :marker-color="markerColor"
              />
            </div>

            <!-- Amenties -->
            <library-properties-property-criteria-list :property="property" class="tw-mt-8" main-list-title="Amenties">
              <template #list-item="{ criteria }">
                <div style="">
                  <h5 class="tw-pb-2">{{ criteria.title }}</h5>

                  <div
                    class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3"
                    style="background-color: var(--c-section_secondary); border-radius: var(--rounded)"
                  >
                    <svg width="28" height="28" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_726_237)">
                        <path
                          d="M50.5655 25.9352L28.0655 3.43521C27.7845 3.15584 27.4043 2.99902 27.008 2.99902C26.6117 2.99902 26.2316 3.15584 25.9505 3.43521L3.45053 25.9352C3.20479 26.2222 3.07638 26.5913 3.09096 26.9688C3.10554 27.3463 3.26204 27.7044 3.52918 27.9716C3.79633 28.2387 4.15444 28.3952 4.53195 28.4098C4.90946 28.4244 5.27858 28.296 5.56553 28.0502L27.0005 6.61521L48.4355 28.0652C48.7225 28.311 49.0916 28.4394 49.4691 28.4248C49.8466 28.4102 50.2047 28.2537 50.4719 27.9866C50.739 27.7194 50.8955 27.3613 50.9101 26.9838C50.9247 26.6063 50.7963 26.2372 50.5505 25.9502L50.5655 25.9352Z"
                          fill="var(--c-primary)"
                        />
                        <path
                          d="M42 48.0001H34.5V33.0001H19.5V48.0001H12V27.0001L9 30.0001V48.0001C9 48.7958 9.31607 49.5588 9.87868 50.1215C10.4413 50.6841 11.2044 51.0001 12 51.0001H22.5V36.0001H31.5V51.0001H42C42.7957 51.0001 43.5587 50.6841 44.1213 50.1215C44.6839 49.5588 45 48.7958 45 48.0001V29.6401L42 26.6401V48.0001Z"
                          fill="var(--c-primary)"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_726_237">
                          <rect width="54" height="54" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <div class="tw-flex tw-flex-col">
                      <p>{{ criteria.value }}</p>
                    </div>
                  </div>
                </div>
              </template>
            </library-properties-property-criteria-list>

            <!-- EPC -->
            <div v-if="property.epc">
              <h3 class="tw-pb-8">EPC</h3>

              <epc :data="property.epcs" :component="component" />
            </div>
          </div>
          <template v-else>

          </template>
        </div>
        <template v-if="!property.is_locked">
          <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
            <div v-if="sidebarComponents && sidebarComponents.length">
              <popup
                v-if="property?.virtual_tour?.mediaLink && virtualTourPopupConfig.isActive"
                :config="virtualTourPopupConfig"
                custom-width="40%"
                class="!tw-z-50"
              >
                <template #content>
                  <iframe
                    class="video"
                    width="100%"
                    height="460"
                    :src="propertyVideo(property?.virtual_tour?.mediaLink)"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </template>
              </popup>
              <div v-if="property" class="tw-bg-white tw-px-6 tw-py-9 lg:tw-px-8 lg:tw-py-12">
                <h3 class="tw-pb-7">Viewing Options</h3>
                <div class="tw-flex tw-flex-col tw-gap-4">
                  <button
                    v-if="property?.virtual_tour?.mediaLink"
                    @click="showVideoTourPopup()"
                    class="n-primary tw-flex tw-items-center tw-justify-center tw-gap-4"
                  >
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.1227 8V16H5.04079V8H15.1227ZM16.1308 6H4.0326C3.76521 6 3.50878 6.10536 3.31971 6.29289C3.13063 6.48043 3.02441 6.73478 3.02441 7V17C3.02441 17.2652 3.13063 17.5196 3.31971 17.7071C3.50878 17.8946 3.76521 18 4.0326 18H16.1308C16.3982 18 16.6547 17.8946 16.8437 17.7071C17.0328 17.5196 17.139 17.2652 17.139 17V13.5L21.1718 17.5V6.5L17.139 10.5V7C17.139 6.73478 17.0328 6.48043 16.8437 6.29289C16.6547 6.10536 16.3982 6 16.1308 6Z"
                        fill="white"
                      />
                    </svg>

                    VIDEO TOUR
                  </button>
                  <button @click="onSendLead()" class="n-primary">BOOK A VIEWING</button>
                </div>
              </div>
              <available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </template>
        <template v-else-if="property.is_locked">
          <library-login />
        </template>
      </div>
      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>
  </div>

  <div v-if="variants.v2 === variant" :style="`background-color: var(--c-${vars.backgroundColor});`">
    <section
      class="n-section-primary !tw-pb-0 !tw-pt-44"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <div class="tw-mb-14 tw-flex tw-w-full tw-pl-5 md:tw-pl-8">
        <library-properties-back-to-all-properties-navbar color="var(--c-primary)" />
      </div>
      <div class="tw-grid tw-grid-cols-12 xl:tw-grid-cols-11 xl:tw-gap-x-16 tw-w-full">
        <div
          class="tw-col-span-12 tw-mb-6 tw-grid tw-w-full tw-grid-cols-12 tw-bg-white tw-px-4 tw-py-6 md:tw-gap-x-10 lg:tw-p-8 xl:tw-col-span-6 xl:tw-mb-0"
          style="border-radius: var(--rounded)"
        >
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-8">
            <h3 class="n-title-primary">Gallery</h3>
            <!-- GALLERY START -->
            <MotionGroup
              is="div"
              preset="slideVisibleBottom"
              :duration="700"
              class="tw-flex tw-w-full tw-cursor-pointer tw-flex-col tw-gap-1 xl:tw-flex-row xl:tw-gap-2"
            >
              <div class="tw-relative tw-flex tw-w-full">
                <library-image
                  :src="property.image"
                  alt="property first image"
                  @click="onClickedImage(primaryFourPhotos[0])"
                  :title="property.advert_heading"
                  :w-ratio="3"
                  :h-ratio="2"
                  image-class="tw-h-full"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <div class="nc-first-image-overlay-item">
                  <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                    1/{{ property.medias.length }}
                  </div>
                </div>
              </div>
              <div class="tw-relative tw-flex tw-gap-1 xl:tw-h-full xl:tw-w-[45%] xl:tw-flex-col xl:tw-gap-2">
                <library-image
                  :src="primaryFourPhotos[1].background"
                  alt="property first image"
                  image-class="tw-w-1/2 xl:tw-h-full xl:tw-w-full"
                  @click="onClickedImage(primaryFourPhotos[1])"
                  :title="property.advert_heading"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"  
                />
                <library-image
                  :src="primaryFourPhotos[2].background"
                  alt="property first image"
                  image-class="tw-w-1/2 xl:tw-h-full xl:tw-w-full"
                  @click="onClickedImage(primaryFourPhotos[2])"
                  :title="property.advert_heading"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
                <button
                  class="tw-absolute tw-bottom-2 tw-right-0 tw-bg-white tw-uppercase tw-text-[var(--c-secondary)] xl:tw-right-1"
                  @click="onClickedImage(primaryFourPhotos[2])"
                >
                  View more
                </button>
              </div>
            </MotionGroup>
            <!-- GALLERY END -->
          </div>
        </div>
        <div
          v-if="property?.featured_video"
          class="tw-col-span-12 tw-grid tw-w-full tw-grid-cols-12 tw-bg-white tw-px-4 tw-py-6 md:tw-gap-x-10 lg:tw-p-8 xl:tw-col-span-5"
          style="border-radius: var(--rounded)"
        >
          <h3 class="n-title-primary tw-col-span-12 tw-pb-8">Walkthrough Video</h3>
          <div
            class="video-landscape tw-col-span-12 tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
            style="border-radius: var(--rounded)"
          >
            <library-iframe
              :src="propertyVideo(property?.featured_video.mediaLink)"
              :w-ratio="16"
              :h-ratio="9"
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"  
            />
          </div>
        </div>
      </div>
    </section>
    <section
      v-if="property"
      class="n-section-primary !tw-pb-10 !tw-pt-5 xl:!tw-pb-14"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <MotionGroup is="div" class="tw-flex tw-flex-col" preset="fadeVisible" :duration="700">
        <div
          class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between tw-px-4 tw-py-6 lg:tw-items-start lg:tw-p-8"
        >
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7" :class="property.is_locked ? 'lg:!tw-col-span-12 xl:!tw-col-span-7' : ''">
            <h2 class="n-title-primary tw-leading-tight">{{ property.advert_heading }}</h2>
            <div
              v-if="property.custom_property_status_title"
              class="tw-my-2 tw-w-fit tw-p-2"
              style="background-color: var(--c-primary); color: white; border-radius: var(--rounded)"
            >
              {{ property.custom_property_status_title }}
            </div>

            <div class="tw-mt-6">
              <p v-if="property.price.type.name" class="tw-mb-0">
                {{ property.price.type.name }}
              </p>
              <h4>{{ property.price.price }}</h4>
            </div>

            <div class="tw-mt-5 tw-flex tw-h-8 tw-flex-row tw-items-center tw-gap-2">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="black"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="black"
                />
              </svg>
              <small>{{ property.display_address }}</small>
            </div>

            <div v-if="!property.is_locked" class="tw-mt-6 tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
              <div v-if="property.bedroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2 19V13C2 12.55 2.09167 12.1417 2.275 11.775C2.45833 11.4083 2.7 11.0833 3 10.8V8C3 7.16667 3.29167 6.45833 3.875 5.875C4.45833 5.29167 5.16667 5 6 5H10C10.3833 5 10.7417 5.071 11.075 5.213C11.4083 5.355 11.7167 5.55067 12 5.8C12.2833 5.55 12.5917 5.35433 12.925 5.213C13.2583 5.07167 13.6167 5.00067 14 5H18C18.8333 5 19.5417 5.29167 20.125 5.875C20.7083 6.45833 21 7.16667 21 8V10.8C21.3 11.0833 21.5417 11.4083 21.725 11.775C21.9083 12.1417 22 12.55 22 13V19H20V17H4V19H2ZM13 10H19V8C19 7.71667 18.904 7.47933 18.712 7.288C18.52 7.09667 18.2827 7.00067 18 7H14C13.7167 7 13.4793 7.096 13.288 7.288C13.0967 7.48 13.0007 7.71733 13 8V10ZM5 10H11V8C11 7.71667 10.904 7.47933 10.712 7.288C10.52 7.09667 10.2827 7.00067 10 7H6C5.71667 7 5.47933 7.096 5.288 7.288C5.09667 7.48 5.00067 7.71733 5 8V10ZM4 15H20V13C20 12.7167 19.904 12.4793 19.712 12.288C19.52 12.0967 19.2827 12.0007 19 12H5C4.71667 12 4.47933 12.096 4.288 12.288C4.09667 12.48 4.00067 12.7173 4 13V15Z"
                        fill="#074873"
                      />
                    </svg> </span
                  >{{ property.bedroom }} Beds</small
                >
              </div>
              <div v-if="property.bathroom">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H9V6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6V5C11 4.46957 10.7893 3.96086 10.4142 3.58579C10.0391 3.21071 9.53043 3 9 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V11H4C3.46957 11 2.96086 11.2107 2.58579 11.5858C2.21071 11.9609 2 12.4696 2 13V14C1.99996 14.9783 2.23913 15.9417 2.69665 16.8064C3.15417 17.671 3.81618 18.4107 4.625 18.961L4.293 19.293C4.19749 19.3852 4.12131 19.4956 4.0689 19.6176C4.01649 19.7396 3.9889 19.8708 3.98775 20.0036C3.9866 20.1364 4.0119 20.2681 4.06218 20.391C4.11246 20.5138 4.18671 20.6255 4.2806 20.7194C4.3745 20.8133 4.48615 20.8875 4.60905 20.9378C4.73194 20.9881 4.86362 21.0134 4.9964 21.0123C5.12918 21.0111 5.2604 20.9835 5.3824 20.9311C5.50441 20.8787 5.61475 20.8025 5.707 20.707L6.583 19.832C7.037 19.942 7.512 20 8 20H16C16.488 20 16.963 19.942 17.417 19.832L18.293 20.707C18.4816 20.8892 18.7342 20.99 18.9964 20.9877C19.2586 20.9854 19.5094 20.8802 19.6948 20.6948C19.8802 20.5094 19.9854 20.2586 19.9877 19.9964C19.99 19.7342 19.8892 19.4816 19.707 19.293L19.375 18.961C20.1838 18.4107 20.8458 17.671 21.3034 16.8064C21.7609 15.9417 22 14.9783 22 14V13C22 12.4696 21.7893 11.9609 21.4142 11.5858C21.0391 11.2107 20.5304 11 20 11H7V6ZM4 13H20V14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H8C6.93913 18 5.92172 17.5786 5.17157 16.8284C4.42143 16.0783 4 15.0609 4 14V13Z"
                        fill="#074873"
                      />
                    </svg> </span
                  >{{ property.bathroom }} Baths</small
                >
              </div>
              <div v-if="property.reception">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.556 18H18.444C19.3871 18 20.2916 17.6254 20.9585 16.9585C21.6254 16.2916 22 15.3871 22 14.444V12C22 11.4696 21.7893 10.9609 21.4142 10.5858C21.0391 10.2107 20.5304 10 20 10C19.4696 10 18.9609 10.2107 18.5858 10.5858C18.2107 10.9609 18 11.4696 18 12V13.2C18 13.4122 17.9157 13.6157 17.7657 13.7657C17.6157 13.9157 17.4122 14 17.2 14H6.8C6.58783 14 6.38434 13.9157 6.23431 13.7657C6.08429 13.6157 6 13.4122 6 13.2V12C6 11.4696 5.78929 10.9609 5.41421 10.5858C5.03914 10.2107 4.53043 10 4 10C3.46957 10 2.96086 10.2107 2.58579 10.5858C2.21071 10.9609 2 11.4696 2 12V14.444C2 15.3871 2.37465 16.2916 3.04153 16.9585C3.70841 17.6254 4.61289 18 5.556 18Z"
                        stroke="#074873"
                        stroke-width="2"
                      />
                      <path
                        d="M20 10C20 9.07 20 8.606 19.923 8.22C19.7687 7.44401 19.3877 6.73121 18.8282 6.17175C18.2688 5.6123 17.556 5.23132 16.78 5.077C16.394 5 15.93 5 15 5H9C8.07 5 7.606 5 7.22 5.077C6.44401 5.23132 5.73121 5.6123 5.17175 6.17175C4.6123 6.73121 4.23132 7.44401 4.077 8.22C4 8.606 4 9.07 4 10"
                        stroke="#074873"
                        stroke-width="2"
                      />
                      <path d="M20 19V18M4 19V18" stroke="#074873" stroke-width="2" stroke-linecap="round" />
                    </svg> </span
                  >{{ property.reception }} Reception</small
                >
              </div>
              <div v-if="property.floor_area">
                <small class="tw-flex tw-gap-2"
                  ><span
                    ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V5C21 3.897 20.103 3 19 3H5C3.897 3 3 3.897 3 5ZM19.002 19H5V5H19L19.002 19Z"
                        fill="#074873"
                      />
                      <path d="M15 12H17V7H12V9H15V12ZM12 15H9V12H7V17H12V15Z" fill="#074873" />
                    </svg> </span
                  >{{ property.floor_area }}</small
                >
              </div>
            </div>
          </div>
          <div
            v-if="!property.is_locked"
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-pt-0"
          >
            <div class="tw-flex tw-w-full tw-items-center tw-justify-between lg:tw-justify-end lg:tw-gap-8">
              <button class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
            </div>
          </div>

          <template v-if="property.is_locked">
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-pt-12 xl:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8 lg:tw-pt-2 xl:tw-pt-0">
              <library-login />
            </div>
          </template>
        </div>
      </MotionGroup>
    </section>

    <section v-if="!property.is_locked" class="n-section-primary !tw-pt-0" :style="`background-color: var(--c-${vars.backgroundColor});`">
      <div class="tw-grid tw-w-full tw-grid-cols-12 md:tw-gap-x-10">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
          <!-- Property Detail -->
          <div class="tw-flex tw-flex-col tw-gap-16">
            <!-- Features -->
            <MotionGroup
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
              preset="fadeVisible"
              :duration="800"
              is="div"
            >
              <h3 class="n-title-primary !tw-opacity-100">Features</h3>
              <div class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                <div
                  v-for="(feature, index) in property.features"
                  :key="`property-feature-${index}`"
                  class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                >
                  <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </span>
                  <library-text class="tw-text-base" :text="feature"> </library-text>
                </div>
              </div>
            </MotionGroup>

            <!-- Floor Plan -->
            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property.floor_plans"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Floor Plans</h3>
              <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
            </MotionGroup>

            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property?.virtual_tour"
              id="matterport_video"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Matterport Video</h3>
              <library-iframe :src="matterPort" />
            </MotionGroup>

            <!-- Property Info -->
            <MotionGroup
              preset="fadeVisible"
              :duration="800"
              is="div"
              v-if="property.description"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Property Info</h3>
              <div v-html="property.description"></div>
              <div class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6">
                <div
                  v-for="criteria in property.criteria_list"
                  :key="criteria.id"
                  class="tw-flex tw-gap-4 tw-p-4"
                  style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                >
                  <span v-if="criteria.title === 'Parking'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                        fill="#EB2123"
                      />
                    </svg>
                  </span>

                  <span v-else-if="criteria.title === 'Sewerage'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                        fill="#EB2123"
                      />
                    </svg>
                  </span>

                  <span v-else-if="criteria.title === 'Water'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                        fill="#EB2123"
                      />
                    </svg>
                  </span>
                  <span v-else>
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_481_37820)">
                        <path
                          d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                          fill="#EB2123"
                        />
                        <path
                          d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                          fill="#EB2123"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_481_37820">
                          <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <div>
                    <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                    <p>{{ criteria.value }}</p>
                  </div>
                </div>
              </div>
            </MotionGroup>

            <!-- Map -->
            <div
              v-if="property.map_position && property.map_position.lat && property.map_position.lng"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">Map</h3>
              <MotionGroup preset="slideVisibleBottom" :duration="800" is="div">
                <neuron-google-map
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </MotionGroup>
            </div>

            <!-- EPC -->
            <div
              v-if="property?.epcs.length > 0"
              class="tw-bg-white tw-px-4 tw-py-6 lg:tw-p-8"
              style="border-radius: var(--rounded)"
            >
              <h3 class="n-title-primary tw-mb-8 !tw-opacity-100">EPC</h3>
              <MotionGroup preset="slideVisibleBottom" :duration="800" is="div">
                <epc :data="property.epcs" :component="component" />
              </MotionGroup>
            </div>
          </div>
        </div>

        <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
          <div v-if="sidebarComponents && sidebarComponents.length">
            <popup
              v-if="property?.virtual_tour?.mediaLink && virtualTourPopupConfig.isActive"
              :config="virtualTourPopupConfig"
              custom-width="90%"
              class="!tw-z-50"
            >
              <template #content>
                <iframe
                  class="video"
                  width="100%"
                  height="460"
                  :src="propertyVideo(property?.virtual_tour?.mediaLink)"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </template>
            </popup>
            <popup
              v-if="property?.featured_video?.mediaLink && videoTourPopupConfig.isActive"
              :config="videoTourPopupConfig"
              custom-width="90%"
              class="!tw-z-50"
            >
              <template #content>
                <iframe
                  class="video tw-aspect-video tw-h-[200px] tw-justify-self-center md:tw-h-[400px]"
                  :src="propertyVideo(property?.featured_video?.mediaLink)"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </template>
            </popup>
            <div v-if="property" class="tw-bg-white tw-px-6 tw-py-9 lg:tw-px-8 lg:tw-py-12">
              <h3 class="n-title-primary tw-pb-7">Viewing Options</h3>
              <div class="tw-flex tw-flex-col tw-gap-4">
                <button
                  v-if="property?.featured_video?.mediaLink"
                  @click="showVideoTourPopup2()"
                  class="n-primary tw-flex tw-items-center tw-justify-center tw-gap-4"
                >
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-mb-1"
                  >
                    <path
                      d="M15.1227 8V16H5.04079V8H15.1227ZM16.1308 6H4.0326C3.76521 6 3.50878 6.10536 3.31971 6.29289C3.13063 6.48043 3.02441 6.73478 3.02441 7V17C3.02441 17.2652 3.13063 17.5196 3.31971 17.7071C3.50878 17.8946 3.76521 18 4.0326 18H16.1308C16.3982 18 16.6547 17.8946 16.8437 17.7071C17.0328 17.5196 17.139 17.2652 17.139 17V13.5L21.1718 17.5V6.5L17.139 10.5V7C17.139 6.73478 17.0328 6.48043 16.8437 6.29289C16.6547 6.10536 16.3982 6 16.1308 6Z"
                      fill="white"
                    />
                  </svg>

                  VIDEO TOUR
                </button>
                <button
                  v-if="property?.virtual_tour?.mediaLink"
                  @click="showVideoTourPopup()"
                  class="n-primary tw-flex tw-items-center tw-justify-center tw-gap-4"
                >
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-mb-1"
                  >
                    <path
                      d="M15.1227 8V16H5.04079V8H15.1227ZM16.1308 6H4.0326C3.76521 6 3.50878 6.10536 3.31971 6.29289C3.13063 6.48043 3.02441 6.73478 3.02441 7V17C3.02441 17.2652 3.13063 17.5196 3.31971 17.7071C3.50878 17.8946 3.76521 18 4.0326 18H16.1308C16.3982 18 16.6547 17.8946 16.8437 17.7071C17.0328 17.5196 17.139 17.2652 17.139 17V13.5L21.1718 17.5V6.5L17.139 10.5V7C17.139 6.73478 17.0328 6.48043 16.8437 6.29289C16.6547 6.10536 16.3982 6 16.1308 6Z"
                      fill="white"
                    />
                  </svg>

                  360 TOUR
                </button>
                <button @click="onSendLead()" class="n-primary">BOOK A VIEWING</button>
              </div>
            </div>
            <available-components-for-sidebar
              key="property-detail-sidebar"
              key-prefix="property-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </div>
      </div>
      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme5/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme5/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'Theme5PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      activeTab: 'features',
      swiper: {},
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      virtualTourPopupConfig: {
        isActive: false,
      },
      videoTourPopupConfig: {
        isActive: false,
      },
    };
  },

  computed: {
    markerColor() {
      return this.colors.primary;
    },

    ROUTES() {
      return ROUTES;
    },

    primaryFourPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    matterPort() {
      let mediaLink = this.property?.virtual_tour?.mediaLink;
      if (mediaLink && mediaLink.includes('youtu')) {
        return null;
      }
      if (mediaLink && mediaLink.startsWith('http://')) {
        mediaLink = mediaLink.replace('http://', 'https://');
      }
      return mediaLink;
    },

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return !this.vars.isMortgageCalculatorHiddenNumber;
    },

    isStampDutyCalculatorVisible() {
      return !this.vars.isStampDutyCalculatorHiddenNumber;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaNumber;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),

    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },

    propertyVideo(videoLink: string) {
      if (videoLink) {
        // Check if the link is already an embed link
        if (!videoLink.includes('embed')) {
          // Convert the standard YouTube link to an embed link
          let videoId = videoLink.split('v=')[1];
          if (videoId) {
            const ampersandPosition = videoId.indexOf('&');
            if (ampersandPosition !== -1) {
              videoId = videoId.substring(0, ampersandPosition);
            }
            videoLink = `https://www.youtube.com/embed/${videoId}`;
          }
        }

        return videoLink;
      }

      return null;
    },

    showVideoTourPopup() {
      this.virtualTourPopupConfig.isActive = true;
    },

    showVideoTourPopup2() {
      this.videoTourPopupConfig.isActive = true;
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },
});
</script>

<style scoped>
.share-button {
  border: 2px solid var(--camel);
}

.nav-link.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
}

.nav-link {
  color: var(--black);
  font-size: 16px;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  color: var(--nc-classic-black);
  border-radius: 4px;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.photo-next,
.photo-prev {
  position: absolute;
  top: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 44px;
  height: 64px;
  background-color: #fff;
  border-radius: var(--rounded);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  font-size: 26px;
}

.photo-next {
  right: 5%;
}

.photo-prev {
  left: 5%;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card) {
  width: 100% !important;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card figure) {
  border: none !important;
}

::v-deep(.floor-tab) {
  padding: unset !important;
}

::v-deep(.inline-iframe-container iframe) {
  height: 590px;
}

.video-landscape ::v-deep(.video) {
  height: 100%;
  min-height: unset !important;
}

.theme4-floor-plan ::v-deep(figure) {
  height: unset !important;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: unset;
}
.swiper-button-next,
.swiper-button-prev {
  width: unset;
  height: unset;
}

::v-deep(img) {
  border-radius: 4px;
}

.n-primary:hover svg path {
  fill: var(--c-primary);
}

::v-deep(#login) {
  @apply tw-col-span-12 xl:tw-col-span-5;
}

@media (min-width: 1280px) {
  ::v-deep(#send-link-button) {
    margin-top: -52px;
  }
}

@media (min-width: 1540px) {
  ::v-deep(#send-link-button) {
    margin-top: -24px;
  }
}


</style>
